// src/lib/api.ts
import axios from 'axios';

 const API_BASE_URL =
  process.env.REACT_APP_NODE_API_BASE_URL || 'http://localhost:4001';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});
